import { Component } from '@angular/core';
import { AnagraficaUtentiService } from 'src/app/core/anagrafica-utenti.service';

@Component({
  selector: 'app-gestione-utenti',
  template: `
    <div class="card card-w-title">
      <h1>Gestione utenti</h1>
      <app-anagrafica-editor [serviceType]="AnagraficaUtentiService" [itemTitle]="'Utente'" [nameProperty]="'nomeUtente'">
      </app-anagrafica-editor>
    </div>
  `
})
export class GestioneUtentiComponent {
  public AnagraficaUtentiService = AnagraficaUtentiService;
}
